exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".allyesSealAdv[data-v-5042d54f]{position:absolute;right:0;height:45px;overflow:hidden;width:141px;top:50%;margin-top:-23px}.allyesSealAdv img[data-v-5042d54f]{height:45px;width:auto;max-width:none}", ""]);

// exports
